"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.policyEntrypoints = void 0;
exports.policyEntrypoints = {
    can: "iam/can",
    canAll: "iam/canAll",
    canAny: "iam/canAny",
};
//# sourceMappingURL=constants.js.map